module.exports = __webpack_public_path__ + "img/activity.62965c38.jpg";